import { render } from "./pages-table.vue?vue&type=template&id=d99a90d0"
import script from "./pages-table.vue?vue&type=script&lang=js"
export * from "./pages-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__